import { setNavbar } from './set-navbar.js';

export type FabricToolbarSetPageTitleOptions = {
  bgColor?: string;
  fontColor?: string;
  statusBarStyle?: 'dark' | 'light';
};

export type FabricToolbarSetPageTitleApi = (
  title: string,
  options?: FabricToolbarSetPageTitleOptions
) => void;

export const setPageTitle: FabricToolbarSetPageTitleApi = (
  title,
  options = {}
) => {
  const {
    statusBarStyle = 'dark',
    bgColor = '#ffffff',
    fontColor = '#000000',
  } = options;
  return setNavbar({
    bgColor,
    statusBarStyle,
    center: [
      {
        tag: '',
        type: 'text',
        value: title,
        fontColor,
      },
    ],
    right: [
      {
        tag: '',
        type: 'icon',
        value: '',
        iconSize: 30,
      },
    ],
  });
};
